"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var RGPD = /** @class */ (function () {
    function RGPD() {
        if (document.getElementById('cookies-modal')) {
            this.initListeners();
            // @ts-ignore
            this.modal = new window.bootstrap.Modal(document.getElementById('cookies-modal'));
        }
    }
    RGPD.prototype.initListeners = function () {
        var _this = this;
        document.addEventListener("DOMContentLoaded", function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleCookiesBanner()];
                    case 1:
                        _a.sent();
                        $(document).on('click', '#btn_rgpd', function (e) {
                            _this.showModal();
                        });
                        $(document).on('click', '#btn_settings_rgpd', function (e) {
                            RGPD.showPreferences($(e.target));
                        });
                        $(document).on('click', '#accept-all', function () {
                            _this.acceptAllCookies();
                        });
                        $(document).on('click', '#deny-all', function () {
                            _this.denyAll();
                        });
                        $(document).on('submit', '#accordion form', function (e) {
                            _this.validate(e);
                        });
                        $(document).on('click', '.toggle_collapse', function () {
                            _this.toggleIcon();
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    RGPD.prototype.toggleIcon = function () {
        var $el = $(this);
        var $elIcon = $(this).find('.toggle_collapse_icon');
        if ($el.hasClass('collapsed')) {
            $elIcon.empty().html('<i class="fa fa-plus-circle" aria-hidden="true"></i>');
        }
        else {
            $elIcon.empty().html('<i class="fa fa-minus-circle" aria-hidden="true"></i>');
        }
    };
    RGPD.showPreferences = function ($el) {
        $('#accordion').removeClass('d-none');
        $el.addClass('d-none');
    };
    RGPD.prototype.handleCookiesBanner = function () {
        if (localStorage.getItem("showCookiesBanner") !== "false") {
            this.showModal();
        }
    };
    RGPD.prototype.showModal = function () {
        this.modal.show();
    };
    RGPD.prototype.hideModal = function () {
        this.modal.hide();
    };
    RGPD.prototype.denyAll = function () {
        this.storePreferences([]);
        this.acceptRequiredCookies();
    };
    RGPD.prototype.getAllCookies = function () {
        var preferences = [];
        $('#accordion .data_element').each(function () {
            preferences.push({
                'name': $(this).find('.data_type_name').html(),
                'data_type_id': parseInt($(this).find('.data_type_name').attr('data_id'), 10)
            });
        });
        return preferences;
    };
    RGPD.prototype.getAcceptedCookies = function () {
        var preferences = [];
        $('#accordion .data_element').each(function () {
            var $input = $(this).find('input');
            if ($input.prop('checked')) {
                preferences.push({
                    'name': $(this).find('.data_type_name').html(),
                    'data_type_id': parseInt($(this).find('.data_type_name').attr('data_id'), 10)
                });
            }
        });
        this.getRequiredCookies().map(function (preference) {
            preferences.push(preference);
        });
        return preferences;
    };
    RGPD.prototype.getRequiredCookies = function () {
        var preferencesRequired = [];
        $('#accordion .data_element').each(function () {
            if ($(this).find(".float-right i").length !== 0) {
                preferencesRequired.push({
                    'name': $(this).find('.data_type_name').html(),
                    'data_type_id': parseInt($(this).find('.data_type_name').attr('data_id'), 10)
                });
            }
        });
        return preferencesRequired;
    };
    RGPD.prototype.acceptAllCookies = function () {
        var preferences = this.getAllCookies().map(function (preference) {
            return __assign(__assign({}, preference), { active: true });
        });
        this.storePreferences(preferences);
    };
    RGPD.prototype.acceptRequiredCookies = function () {
        var preferences = this.getRequiredCookies().map(function (preference) {
            return __assign(__assign({}, preference), { active: true });
        });
        this.storePreferences(preferences);
    };
    RGPD.prototype.validate = function (e) {
        e.preventDefault();
        var preferences = this.getAcceptedCookies().map(function (preference) {
            return __assign(__assign({}, preference), { active: true });
        });
        this.storePreferences(preferences);
    };
    RGPD.prototype.storePreferences = function (preference) {
        this.hideModal();
        localStorage.setItem("showCookiesBanner", "false");
        this.setCookie("cookiesPreferences", JSON.stringify(preference));
    };
    RGPD.prototype.setCookie = function (cname, cvalue, exdays) {
        if (exdays === void 0) { exdays = 180; }
        document.cookie = cname + "=;Thu, 01 Jan 1970 00:00:01 GMT;path=/";
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
    return RGPD;
}());
exports.default = RGPD;
